import queryString from 'query-string';

/**
 * Create url with UTM parameters
 */
export default function utmUrl(
  url,
  { source = 'localsearch_online', medium = 'test', campaign, ...query } = {}
) {
  const tags = {
    utm_source: source,
    utm_medium: medium,
    utm_campaign: campaign,
    ...query,
  };
  return `${url}?${queryString.stringify(tags)}`;
}
